var _circle, _text, _circle2, _text2, _circle3, _text3, _circle4, _text4, _path, _path2, _path3, _path4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 130,
    r: 30,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 135,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "sans-serif"
  }, "E")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 130,
    r: 30,
    stroke: "#fafcfb",
    strokeWidth: 1.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 135,
    textAnchor: "middle",
    fill: "#fafcfb",
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "sans-serif"
  }, "I")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 130,
    r: 30,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 135,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "sans-serif"
  }, "E")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 130,
    r: 30,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 135,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "sans-serif"
  }, "R")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 130 L140 130",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 130 L210 130",
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M270 130 L280 130",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 55,
    r: 2,
    fill: "#fbbf24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEier);
export default __webpack_public_path__ + "static/media/eier.246e4269c6ab2ca9a52cc4c1aa5ec3a3.svg";
export { ForwardRef as ReactComponent };